(() => {
  if (window.__evalModalTurboInit) return;
  window.__evalModalTurboInit = true;

  document.addEventListener('turbo:before-stream-render', (event) => {
    const stream = event.target;
    if (!(stream instanceof Element) || stream.getAttribute('target') !== 'eval_modal_placeholder') return;

    const originalRender = event.detail.render;
    event.detail.render = (currentElement, newElement) => {
      originalRender(currentElement, newElement);

      const modalElement = document.getElementById('evaluation_modal');
      if (!modalElement) return;

      const placeholder = $('#eval_modal_placeholder');
      modalElement.addEventListener('hidden.bs.modal', () => {
        placeholder.empty();
      }, { once: true });

      const bsModal = window.bootstrap?.Modal?.getOrCreateInstance(modalElement);
      bsModal?.show();
    };
  });
})();
